module.exports = __webpack_public_path__ + "img/goods.ce81602a.png";